/**
 * Agentic trending strip: wheel → horizontal scroll; pointer drag on desktop.
 */
(function () {
  'use strict';

  function initTrack(track) {
    if (track.dataset.esTrendingInit === '1') return;
    track.dataset.esTrendingInit = '1';

    track.addEventListener(
      'wheel',
      function (e) {
        if (track.scrollWidth <= track.clientWidth + 1) return;
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        e.preventDefault();
        track.scrollLeft += e.deltaY;
      },
      { passive: false }
    );

    var dragging = false;
    var pointerActive = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var pointerId = null;
    var DRAG_THRESHOLD = 6;

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || track.scrollWidth <= track.clientWidth + 1) return;
      pointerActive = true;
      moved = false;
      dragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      pointerId = e.pointerId;
    });

    track.addEventListener('pointermove', function (e) {
      if (!pointerActive) return;

      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) >= DRAG_THRESHOLD) {
        moved = true;
        dragging = true;
        try {
          track.setPointerCapture(pointerId);
        } catch (err) {}
        track.classList.add('is-dragging');
      }

      if (!dragging) return;
      e.preventDefault();
      track.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!pointerActive) return;
      pointerActive = false;

      if (dragging) {
        dragging = false;
        track.classList.remove('is-dragging');
        try {
          track.releasePointerCapture(pointerId);
        } catch (err) {}
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }

  function boot() {
    document.querySelectorAll('.es-agentic-trending__track').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
